const safeJsonParse = <T>(str: string) => {
	try {
		return JSON.parse(str) as T;
	} catch {
		return {} as T;
	}
};

export { safeJsonParse };
